fx.ns("desktop.book", class Main extends shared.BookMain {

	constructor() {
		super();

		fx.set("app-device", "app-desktop");
		fx.set("app", "book");
		fx.set("app-project", this.is3d ? "3d" : "standard");
	}

	init() {

		this.views = ["desktop.common.screens.Splash",
			//"desktop.common.screens.CoverAlbum",
			"shared.screens.CoverAlbum",
			//"desktop.common.screens.ShapeAlbum",
			"shared.screens.ShapeAlbum",
			//"desktop.common.screens.SizeAlbum",
			"shared.screens.SizeAlbum",
			//"desktop.common.screens.HardCover",
			"shared.screens.HardCover",
			"desktop.common.preview.Preview",
			//"desktop.common.preview.PreviewAI",
			"desktop.book.edition.BookEditor",
			"desktop.common.photoimport.PhotoChoices",
			"desktop.common.panels.SelectPhotosPanel",
			//"desktop.book.edition.ThemeCategories",
			"shared.screens.ThemeCategories",
			"shared.screens.MagicAlbumPanel",
			"shared.screens.Saving",
			"desktop.common.photoimport.AlbumsPhotos",
			"desktop.common.photoimport.GooglePanel",
			"desktop.common.photoimport.FacebookPanel",
			"desktop.common.photoimport.InstagramPanel",
			"desktop.common.photoimport.UploadProgress",
			"desktop.common.screens.SuspendedBook",
			"desktop.common.panels.InfoPanel",
			"desktop.common.panels.SharedPhotosPanel",
			"desktop.common.panels.CheckBookPanel",
			//"desktop.common.panels.ChangeLayoutsPanel",
			//"desktop.common.panels.ChangeThematicsPanel",
			"desktop.common.panels.ChangeThemesPanel",
		];

		fx.enableToolTip();

		if (fx.browser.isTablet && !Utils.getURLParam("desktop")) // case for IPAD pro that appear as desktop
			this.navigateToURL(window.location.pathname + "?tablet=true" + (this.previewMode ? "&preview=true" : ""));

		this.on("TAB-DOWN", this._toggleGridMode, fx.keyboard);
	}


	onDataEvent(e) {
		switch (e.type) {
			case "start":
				if (this.model.creationid) {
					this.steps({ view: "Splash", skipPrevious: true }, this.previewMode ? "CheckBookPanel" : "BookEditor");
				}
				else
					if (this.is3d) {
						fx.set("mode", "creating");
						let steps = [];

						// 3D book, by default no choice, 21x21cm soft cover
						//steps.push("SizeAlbum");
						//steps.push("CoverAlbum");
						//steps.push("HardCover");
						steps.push("Splash");
						steps.push("BookEditor");

						this.steps(steps);
					}
					else
						if (this.ia) {
							fx.set("mode", "creating-ia");

							// the format and the cover are asked by the order button, like any other book
							this.markCreationChoicesPending();

							// magic album : the photos, then the MagicAlbumPanel (title, placement in the
							// browser) which opens the editor once the album is placed
							this.steps({ view: "Splash", skipPrevious: true },
								"PhotoChoices",
								"MagicAlbumPanel"
							);
						}
						else {
							fx.set("mode", "creating");

							// A book goes straight to the editor : neither the theme, nor the format,
							// nor the cover are asked here any more. The order button asks for the
							// format and the cover that are still missing.
							this.markCreationChoicesPending();

							let steps = [];

							// stapled notebook and hard layflat products : the shape is asked first
							// (the shape screen leaves the square out for the stapled one)
							if (this.shapeAskedAtCreation)
								steps.push("ShapeAlbum");

							steps.push("Splash");
							steps.push("BookEditor");

							this.steps(steps);
						}

				break;


			case "creation-created":
			case "creation-loaded":
				fx.service("PhotoSharingService").start();
				super.onDataEvent(e);

				//if (this.previewMode)
				//{
				//	if (this.model.report().failed)	// Display warning popup only if there are reports on one/several page(s) or if number of pages is not a multiple of 4
				//	{
				//this.model.event("checkbook-panel", null, 1500);
				//this.switchTo("BookEditor");
				//this.switchTo("CheckBookPanel");
				//	}
				//	else	
				//	{
				//        this.model.event("navigate-order");
				//this.switchTo("Preview");
				//this.switchTo("ProposePreviewPanel");
				//this.popup(new common.popups.ProposePreview(this.model, true));
				//	}
				//}

				break;

			case "show-editor":
				if (this._lastView == "Preview" && this.currentView == "InfoPanel") {
					this.switchTo("Preview");
					fx.service("PhotoSharingService").stop();
				}
				else if (this.model.creation.suspended && !Utils.getURLParam("connectionid") /*!this.model.connectionid*/) {
					this.switchTo("SuspendedBook");
					fx.service("PhotoSharingService").stop();
				}
				else {
					this.actionRequested = ""
					this.switchTo("BookEditor");
					fx.service("PhotoSharingService").start();
				}
				break;

			case "book-suspended":
				if (!Utils.getURLParam("connectionid")) {
					this.switchTo("SuspendedBook");
					fx.service("PhotoSharingService").stop();
				}
				break;

			/*case "confirm-delete-photo":
				this.popup(new shared.popups.ConfirmDeletePhoto(e.data))
				break;*/

			case "cover-update-impossible":
				this.popup(new common.popups.CoverUpdateImpossible(this.model, e.data))
				break;

			case "shape-album":
				this.switchTo("ShapeAlbum");
				break;

			/*case "select-cover":
				this._lastView = this.currentView;
				//this.switchTo("CoverAlbum", e.data);
				this.steps("CoverAlbum", "HardCover")
				break;

			case "cover-selection-finished":
				if (this._lastView)
					this.switchTo(this._lastView);
				break;*/

			/*case "cover-not-updated":
				this.model.event("show-editor");
			break;*/

			case "select-hard-cover":
				this.switchTo("HardCover");
				break;

			case "preview":
				this.switchTo("Preview");
				break;

			case "selectphotos":
				this.switchTo("PhotoChoices", {model : this.model, component : e.detail});
				break;

			/*case "photo-choice-back" :
				if (this.ia)
					this.switchTo("CoverAlbum");
				else
					this.switchTo("BookEditor");
				break;
			*/
			case "photos-files-selected":
				if (!this.ia)
					this.switchTo("BookEditor");
				break;

			// magic album (creating-ia) keeps its own wizard ; the standard book uses the shared
			// SelectPhotosPanel flow (BaseMain helpers)
			case "import-mobile":
				if (fx.get("mode") == "creating-ia")
					this.popup(new shared.popups.EnterPhoneNumber(this.model));
				else
					this._startMobileImport();
				break;

			// the phone started sending : magic album advances its wizard ; standard book shows the screen
			case "mobile-upload-started":
				if (fx.get("mode") == "creating-ia") {
					this.popup(null);
					if (this.currentView == "PhotoChoices")
						this.model.event("next-step");
				}
				else
					this._showMobileImport();
				break;

			case "mobile-upload-finished":
				if (fx.get("mode") == "creating-ia" && this.currentView == "PhotoChoices")
					this.model.event("next-step");
				break;

			case "mobile-upload-send":
				// magic album : "sent" popup until the phone sends ; standard book shows the screen
				if (fx.get("mode") == "creating-ia")
					this.popup(new shared.popups.EnterPhoneSuccess(this.model), { closeCurrent : true});
				else
					this._showMobileImport();
				break;

			// import-photos-validated / -early / -cancelled are handled by BaseMain (SelectPhotosPanel)


			case "shared-photos-panel":
				this.switchTo("SharedPhotosPanel", this.model);
				break;


			case "order":
				this.actionRequested = "";

				if (desktop.common.panels.CheckBookPanel.hasIssues(this.model.report()))	// empty pages or zones, or a page count not a multiple of 4
					this.switchTo("CheckBookPanel");
				else
					this.model.event("propose-preview");

				break;

			case "creation-choice-done":
				this.nextCreationChoice();
				break;

			case "creation-choice-previous":
				this.previousCreationChoice();
				break;

			case "check-creation-confirmed":
				//if (this.previewMode)
				//	this.model.event("order-confirmed");
				//else
					this.model.event("propose-preview");
				break;

			case "order-confirmed":
				// ordering is a commitment : the creation has to exist in the account even if the
				// client changed nothing, or the night cleaning takes its photos
				this.model.undelete();

				// format / cover were not asked at creation : ask for them once the preview
				// has been seen, just before the cart
				if (this.startCreationChoices())
					break;

				if (this.readyLeaving(e.type))
					this.model.event("navigate-order", null, fx.service("PdfUploader").converting ? 250 : 0);
				break;

			case "exit-editor":
				if (this.readyLeaving(e.type))
					this.model.event("navigate-exit", fx.service("PdfUploader").converting ? 250 : 0);

				break;

			case "screen-saving":
				this.switchTo("Saving");
				break;

			case "propose-preview":

				if (fx.get("mode") == "creating-ia" || this.ia)
					this.model.event("order-confirmed");
				else
					this.switchTo("Preview");

				break;

			/*case "change-theme-ai" :
				this.steps("ThemeCategories", 
								"ThemeAlbum", 
								"TypeAlbum", 
								"PreviewAI");
				break;*/

			case "upload-progress-closed":
				this.actionRequested = "";
				break;


			/***************** infoPanel / Soze / Cover *****************/
			case "size-album":
				this.switchTo("SizeAlbum");
				break;

			case "cover-album":
				this.steps("CoverAlbum", "HardCover");
				break;

			case "place-photos-chronologically":
				this._lastView = this.currentView;
				this.switchTo("MagicAlbumPanel");
				break;

			case "info-panel":
				this._lastView = this.currentView;
				this.switchTo("InfoPanel")
				break;

			case "checkbook-panel":
				this._lastView = this.currentView;
				this.switchTo("CheckBookPanel");
				break;

			case "change-thematics":
				this.popup(new desktop.common.panels.ChangeThematicsPanel(this.model));
				break;

			case "change-themes":
				this._lastView = this.currentView;
				this.switchTo("ChangeThemesPanel", e.data);
				break;

			case "size-selection-finished":
			case "cover-selection-finished":
				this.switchTo("InfoPanel");
				break;

			case "info-panel-exit":
				this.switchTo(this._lastView || "BookEditor")
				break;

			/***************** Import pictures *****************/

			case "import-facebook":
				this.popup(new desktop.common.photoimport.FacebookPanel(this.model));
				break;

			case "import-google":
				this.popup(new desktop.common.photoimport.GooglePanel(this.model));
				break;

			case "import-instagram":
				this.popup(new desktop.common.photoimport.InstagramPanel(this.model));
				break;

			case "import-albums":
				this.popup(new desktop.common.photoimport.AlbumsPhotos(this.model));
				break;

			case "album-photos-copied":
			case "instagram-photos-added":
			case "facebook-photos-added":
			case "google-photos-added":
			case "local-photos-selected":

				// magic album : enough photos picked, on to the MagicAlbumPanel (its steps wait for
				// the extraction, started here as the uploader leaves it to us in this mode)
				if (fx.get("mode") == "creating-ia" && this.currentView == "PhotoChoices") {
					// the photos already picked count (the selection can be completed in several goes)
					if (this.model.photos.active.length + e.detail.length < 20)
						this.popup(new shared.popups.MessagePersonPopup(fx.text("Nombre de photos insuffisant"), fx.text("Veuillez sélectionner au minimum 24 photos.")));
					else {
						if (e.type == "local-photos-selected")
							fx.service("MediasUploader").photoExtractor.process(e.detail);

						this.model.event("next-step");
					}
				}
				else
					this.model.event("show-editor");

				break;


			case "upload-progress":
				if (this.currentPopup instanceof desktop.common.photoimport.UploadProgress)
					return;

				this.popup(new desktop.common.photoimport.UploadProgress(this.model));
				break;

			case "file-already-processing":
				this.popup(new shared.popups.FileAlreadyProcessing(this.model));
				break;

			case "file-uploaded":
				this.popup(new shared.popups.FileUploaded());
				break;

			case "file-upload-failed":
			case "file-conversion-error":
				this.popup(new shared.popups.FileUploadFailed(this.model));
				break;

			/*case "file-conversion-finished":
				this.popup(new shared.popups.FileConversionFinished());
				break;*/

			case "file-uploading":
				this.popup(new shared.popups.ConversionPdfFiles(e.model))
				break;

			case "failed-photos-canceled":
				if (this.currentView == "MagicAlbumPanel" && fx.get("mode") == "creating-ia")
					this.model.event("previous-step");
				break;

			case "cover-updated":
				//if (fx.get("mode") == "edition")
				//this.popup(new common.popups.CoverChanged(fx.get("mode")));
				break;

			/*case "notice-select-files" : 
				this.popup(new shared.popups.NoticeSelectFiles(e.model))
				break;*/

			/*case "conversion-pdf-files" : 
				this.popup(new shared.popups.ConversionPdfFiles(e.model))
				break;*/



			/*case "ia-analyse" :
				this.popup(new shared.popups.IACreationPopup(this.model));
				break;*/




			/******************** Navigation ********************/



			default:
				super.onDataEvent(e);
				break;

		}
	}

	// _mobileImportData() and _discardPhotos() moved to shared.BaseMain (shared by every product)

	_toggleGridMode(e) {
		fx.get("settings").toggleGridMode();

		e.stopPropagation();
		e.preventDefault();
	}







});